import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { UserGroup } from '../models/user-group';
import { JsonHttpService } from '../../shared/http/json-http.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UserGroupService {

    constructor(private httpService: JsonHttpService) { }

    /**
     * Get UserGroups for the given parameters
     * @param includeRoles True if the UserGroup objects should contain Role objects
     * @param includeDataGroups True if the UserGroup objects should contain DataGroup objects
     */
    getUserGroups(userGroupIds?: number[]): Promise<UserGroup[]> {
        return firstValueFrom( this.httpService.postTyped<UserGroup[]>('/api/users/groups/get-groups', userGroupIds));
    }

    saveUserGroup(usergroup: UserGroup): Promise<UserGroup> {
        return this.httpService.post('/api/users/groups/save-group', usergroup).toPromise();
    }

    deleteUserGroup(userGroupId: number): Promise<void> {
        const options = { params: new HttpParams().set('userGroupId', `${userGroupId}`) };
        return this.httpService.post('/api/users/groups/delete-group', null, options).toPromise();
    }

    groupNameAvailable(userGroupName: string): Promise<boolean> {
        const options = { params: new HttpParams().set('userGroupName', userGroupName) };
        return this.httpService.get('/api/users/groups/group-name-available', options).toPromise();
    }
}
